import { queryOptions } from '@tanstack/react-query';

import { getExchangeRateToday } from '../api/fetcher';

export const currencyQueryOptions = {
  getExchangeRateToday: () =>
    queryOptions({
      queryKey: ['currency', 'exchange-rate', 'today'],
      queryFn: getExchangeRateToday,
      staleTime: 1000 * 60 * 60,
      refetchInterval: 1000 * 60 * 60,
    }),
};
